import AppleIcon from '~/assets/icons/Apple';
import FacebookIcon from '~/assets/icons/Facebook';
import GoogleIcon from '~/assets/icons/Google';

const OtherLoginOptionsMessage = ({
  isOnBlack = false
}: {
  isOnBlack: boolean;
}) => {
  const iconColours = isOnBlack ? 'white' : 'black';

  return (
    <div>
      <div className="flex flex-row items-center justify-center gap-3">
        <GoogleIcon colour={iconColours} size={14} />
        <AppleIcon colour={iconColours} width="16" height="16" />
        <FacebookIcon fill={iconColours} width="20" height="20" />
      </div>
      <h3
        className={`px-2 pb-4 pt-1 text-center font-normal ${
          isOnBlack ? 'text-white' : 'text-grey-read'
        }`}
      >
        Open in your external browser to see other log in options
      </h3>
    </div>
  );
};

export default OtherLoginOptionsMessage;
